import React from 'react';
import { Link } from 'react-router-dom';
import logoImage from '../assets/logo-corrected.png';

const Header = () => {
  return (
    <>
      <header className="header">
        <div className="logo-container">
          <Link to="/">
            <img 
              src={logoImage} 
              alt="The Wild Garden Logo" 
              className="logo"
            />
            <div className="logo-text">
              THE WILD GARDEN
            </div>
          </Link>
          <div className="subtitle">• WEDDING, LIFESTYLE, CORPORATE •</div>
        </div>
      </header>
      <div className="wave-container"></div>
    </>
  );
};

export default Header;
